import { useState, useMemo, useRef } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { ModalRef } from "@shared/components";
import { MagazineTemplate } from "@modules/magazineTemplates/types";

export function useMagazineTemplatesList() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const createMagazineTemplatesModalRef = useRef<ModalRef>(null);
  const editMagazineTemplatesModalRef = useRef<ModalRef>(null);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<MagazineTemplate>({
    resource: "v2/magazine/magazine_template_admin",
    filters: getQueryParams(),
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    createMagazineTemplatesModalRef,
    editMagazineTemplatesModalRef,
    selectedRows,
    dataToExport,
    refetch,
    setSelectedRows,
    translate,
  };
}
